import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const client = axios.create({ baseURL: API, timeout: 120000 });

function toMessage(err) {
  if (err.response) {
    const d = err.response.data && err.response.data.detail;
    if (typeof d === "string") return { status: err.response.status, message: d };
    if (err.response.status === 422) return { status: 422, message: "Input tidak valid. Periksa panjang dan isi teks Anda." };
    return { status: err.response.status, message: "Terjadi kesalahan pada layanan AI. Silakan coba lagi." };
  }
  if (err.code === "ECONNABORTED") return { status: 0, message: "Permintaan melewati batas waktu. Silakan coba lagi." };
  return { status: 0, message: "Tidak dapat menghubungi server. Periksa koneksi internet Anda." };
}

async function post(path, body) {
  try {
    const { data } = await client.post(path, body);
    return data;
  } catch (e) {
    throw toMessage(e);
  }
}

export const aiStatus = () => client.get("/ai-status").then((r) => r.data).catch(() => ({ configured: false, model: "-", provider: "Google Gemini", unreachable: true }));
export const fetchRecommendations = (b) => post("/recommendations", b);
export const fetchAnalysis = (b) => post("/analyze-argument", b);
export const fetchFollowup = (b) => post("/followup", b);
